// App.js
import React, { useEffect, useState } from "react"
import "./App.css"
import { onAuthStateChanged, signInWithPopup, signOut } from "firebase/auth"
import Homepage from "./homepage"
import MainSite from "./mainSite"
import OutputPage from "./outputpage"
import BubbleChart from "./bubblePage" // Make sure this matches your actual filename
import LoginPage from "./LoginPage"
import { auth, googleProvider } from "./firebase"
import PortfolioPage from "./portfolioPage"

function App() {
  const [page, setPage] = useState("landing")
  const [user, setUser] = useState(null)
  const [authLoading, setAuthLoading] = useState(true)
  const [authError, setAuthError] = useState("")

  const handleNavigate = (nextPage) => {
    setPage(nextPage)
  }

  const handleUnlockBeta = () => {
    setPage("home")
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser)
      setAuthLoading(false)
    })

    return () => unsubscribe()
  }, [])

  useEffect(() => {
    if (!user && !authLoading) {
      const protectedPages = ["bubble", "output", "portfolio"]
      if (protectedPages.includes(page)) {
        setPage("login")
      }
    }
  }, [user, page, authLoading])

  const handleLogin = async () => {
    setAuthError("")
    try {
      await signInWithPopup(auth, googleProvider)
      setPage("home")
    } catch (err) {
      console.error("Google sign-in failed:", err)
      setAuthError("Google sign-in failed. Please try again.")
      throw err
    }
  }

  const handleLogout = async () => {
    try {
      await signOut(auth)
    } catch (err) {
      console.error("Sign out failed:", err)
    } finally {
      setPage("landing")
    }
  }

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-purple-700">
        Connecting to Neo...
      </div>
    )
  }

  return (
    <>
      {page === "landing" && (
        <Homepage
          onNavigate={handleNavigate}
          onUnlockBeta={handleUnlockBeta}
        />
      )}
      {page === "home" && (
        <MainSite
          onNavigate={handleNavigate}
          user={user}
          onLogout={user ? handleLogout : null}
        />
      )}
      {page === "login" && (
        <LoginPage onLogin={handleLogin} error={authError} />
      )}
      {page === "output" && (
        <OutputPage onNavigate={handleNavigate} user={user} onLogout={user ? handleLogout : null} />
      )}
      {page === "bubble" && (
        <BubbleChart onNavigate={handleNavigate} user={user} onLogout={user ? handleLogout : null} />
      )}
      {page === "portfolio" && (
        <PortfolioPage onNavigate={handleNavigate} user={user} onLogout={user ? handleLogout : null} />
      )}
    </>
  )
}

export default App
